import React from 'react';
import styled, { keyframes } from 'styled-components';

const animation1 = keyframes`
  0% {
    transform: rotate(0deg) translateX(25px) scale(4);
  }
  25% {
    transform: rotate(90deg) translateX(25px) scale(8);
  }
  50% {
    transform: rotate(180deg) translateX(25px) scale(4);
  }
  75% {
    transform: rotate(270deg) translateX(25px) scale(0);
  }
  100% {
    transform: rotate(360deg) translateX(25px) scale(4);
  }
`;

const animation2 = keyframes`
  0% {
    transform: rotate(0deg) translateX(-25px) scale(4);
  }
  25% {
    transform: rotate(90deg) translateX(-25px) scale(0);
  }
  50% {
    transform: rotate(180deg) translateX(-25px) scale(4);
  }
  75% {
    transform: rotate(270deg) translateX(-25px) scale(8);
  }
  100% {
    transform: rotate(360deg) translateX(-25px) scale(4);
  }
`;

const Container = styled.div`
  width: 300px;
  height: 300px;
  position: relative;
`;

const Circle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background-color: #4c12a1;
  border-radius: 50%;
`;

const PurpleCircle1 = styled(Circle)`
  animation: ${animation1} 1.639344262295082s infinite linear;
`;

const PurpleCircle2 = styled(Circle)`
  animation: ${animation2} 1.639344262295082s infinite linear;
`;

function Spinner() {
  return (
    <Container>
      <PurpleCircle1 />
      <PurpleCircle2 />
    </Container>
  );
}

export default Spinner;
